import { render, staticRenderFns } from "./CustomersExpiringList.vue?vue&type=template&id=97a39b80"
import script from "./CustomersExpiringList.vue?vue&type=script&lang=js"
export * from "./CustomersExpiringList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports